import "./style.scss";
import { useState } from "react";
import AOPConfig from "./AOPConfig/AOPConfig";
import AOPPrev from "./AOPPrev/AOPPrev";

const AOPDegreeDocumentsSwissLayout = () => {
  const [showDegreePdf, setShowDegreePdf] = useState(false);

  return (
    <div className="container admission-office-page degree-documents">
      <AOPConfig setShowDegreePdf={setShowDegreePdf} />
      <AOPPrev showDegreePdf={showDegreePdf} />
    </div>
  );
};

export default AOPDegreeDocumentsSwissLayout;
